import { Checkbox } from "@mui/material";

const ChildCheckBox = ({ addTestCase, caseToBeAdded, item }) => {
  return (
    <Checkbox sx={{ p: 0, mr: 2 }} onChange={addTestCase} checked={caseToBeAdded?.includes(item)} />
  );
};

export default ChildCheckBox;
